// ======================================================================
// File Name       : SelectGroupDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { change } from 'redux-form';
import { Modal, Form, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { MESSAGE_TYPE, MESSAGE_TIME_OUT, MODAL_SIZE } from '../constants/index';
import TreeView from '../components/Tree';
import ModalWrapper from '../components/modal/ModalWrapper';
import * as groupActions from '../actions/GroupAction';
import * as Functions from '../constants/FunctionConstants';
import TREE_ICON from '../images/tree/default-icon.png';
import { canAccess } from '../utils/AuthedUtils';
import RenderField from '../utils/ReduxFormUtils';
import { createTree } from '../utils/groupUtils';

class SelectGroupDialog extends React.Component {
  constructor(props) {
    super(props);
    this.onOK = this.onOK.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentWillMount() {
    const { dispatch, groupList } = this.props;
    if (!groupList || (groupList && groupList.length <= 0)) {
      this.props.dispatch(groupActions.fetchGroupStructure());
    }
  }

  onOK() {
    const { formKey } = this.props;
    const form = this.props.form[formKey];
    if (form && form.values) {
      const { selectedTargetGroup } = form.values;
      this.props.dispatch(groupActions.selectedGroupOnDialog(selectedTargetGroup));
    }
    this.props.closeSelectGroupDialog();
  }

  onCancel() {
    this.props.dispatch(change(this.props.formKey, 'selectedTargetGroup', null));
    this.props.closeSelectGroupDialog();
  }

  render() {
    const { groupList, selectedTargetGroup } = this.props;
    const nodes = createTree(groupList, false, selectedTargetGroup);
    return (
      <Modal
        show={this.props.show}
        animation={false}
        size={'lg'}
        dialogClassName="max-width-600"
        backdropClassName="child-opacity"
        style={this.props.style}
      >
        <Modal.Header onHide={this.onCancel} closeButton>
          <Modal.Title className="text-center">ユーザーグループを選択してください</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: '50vh' }}>
          <Col sm={12}>
            <RenderField name={'selectedTargetGroup'} data={nodes} type="tree" />
          </Col>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button key={0} className="btn-96" onClick={this.onCancel} variant='default'>
            {'キャンセル'}
          </Button>
          <Button key={1} className="btn-96" variant="primary" onClick={this.onOK}>
            {'OK'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { selectedTargetGroup, groupList } = state.group;
  const form = state.form;
  return { selectedTargetGroup, form, groupList };
};

export default connect(mapStateToProps)(SelectGroupDialog);
